import { FDealType, getDealTypeFromJsonQuery, getRangeValue } from '@/packages/JsonQuery';

import { type ITagGroupConfig } from '../types';
import { getRangeText } from '../utils/getRangeText';

export const roomsInDeal: ITagGroupConfig = {
  get({ jsonQuery }) {
    const value = getRangeValue('rooms_for_sale')(jsonQuery);
    const rangeText = getRangeText(value);
    if (!rangeText) {
      return null;
    }

    const dealType = getDealTypeFromJsonQuery(jsonQuery);
    const dealTypeText = dealType === FDealType.Sale ? 'на продажу' : 'в аренду';

    return [
      {
        group: 'roomsInDeal',
        text: `Комнат ${dealTypeText}: ${rangeText}`,
      },
    ];
  },
  delete({ onChange }) {
    onChange(
      {
        action: 'setRoomsForSaleMin',
        arguments: [null],
      },
      {
        action: 'setRoomsForSaleMax',
        arguments: [null],
      },
    );
  },
};
